<template>
  <el-dialog width="800px" :visible.sync="linkVisible" :title="`${formData.id ? '编辑' : '新建'}联系人`" @close="closeForm">
    <el-form :model="formData" :rules="rules" class="form-data" ref="ruleFormRef" label-width="130px">
      <el-form-item label="姓名" prop="linkName">
        <el-input v-model="formData.linkName" placeholder="请输入姓名" maxLength="30"></el-input>
      </el-form-item>
      <el-form-item label="客户" prop="customerId" v-if="showCust">
        <select-customer @confirm="selctCustConfirm" :name="formData.customerName" />
      </el-form-item>
      <el-form-item label="手机" prop="linkPhone">
        <el-input v-model="formData.linkPhone" placeholder="请输入手机" maxLength="11"></el-input>
      </el-form-item>
      <el-form-item label="是否首要联系人" prop="isChief">
        <el-select v-model="formData.isChief" placeholder="请选择是否首要联系人" clearable>
          <el-option v-for="op in isChiefOptions" :key="op.value" :label="op.label" :value="op.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="职务" prop="linkPost">
        <el-input v-model="formData.linkPost" placeholder="请输入职务" maxLength="30"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="linkEmail">
        <el-input v-model="formData.linkEmail" placeholder="请输入邮箱" maxLength="30"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="linkSex">
        <el-select v-model="formData.linkSex" placeholder="请选择性别" clearable>
          <el-option v-for="op in linkSexOptions" :key="op.value" :label="op.label" :value="op.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark" class="full-width">
        <el-input v-model="formData.remark" rows="3" type="textarea" placeholder="请输入备注" maxLength="500"></el-input>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button type="primary" @click="saveLink">确定</el-button>
      <el-button @click="closeForm">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { CustomerApis } from "@/apis";
import { IsChief, LinkSex } from "@/utils/enum";
import NewTable from "@/components/new-table.vue";
import SelectCustomer from "@/components/select-customer.vue";

export default {
  name: "new-link",
  props: { showCust: Boolean },
  data() {
    return {
      linkVisible: false,
      rules: {
        linkName: [{ required: true, message: "请输入姓名", trigger: "change" }],
        linkPhone: [{ required: true, message: "请输入手机号", trigger: "change" }],
        customerId: [{ required: true, message: "请选择客户", trigger: "change" }],
      },
      formData: {
        id: 0,
        customerId: "",
        customerName: "",
        linkName: "",
        linkPhone: "",
        isChief: "",
        linkPost: "",
        linkEmail: "",
        linkSex: "",
        remark: "",
      },
      isChiefOptions: Object.keys(IsChief).map((key) => {
        return { label: IsChief[key], value: Number(key) };
      }),
      linkSexOptions: Object.keys(LinkSex).map((key) => {
        return { label: LinkSex[key], value: Number(key) };
      }),
    };
  },
  methods: {
    show(row) {
      for (const key in this.formData) {
        this.formData[key] = row[key] === undefined ? "" : row[key];
      }
      this.linkVisible = true;
    },
    async saveLink() {
      await this.$refs.ruleFormRef.validate();
      if (this.formData.id > 0) {
        await CustomerApis.editCustLink(this.formData);
        this.$message.success("修改成功");
      } else {
        await CustomerApis.addCustLink(this.formData);
        this.$message.success("新增成功");
      }
      this.linkVisible = false;
      this.$emit("save");
    },
    closeForm() {
      this.$refs.ruleFormRef.resetFields();
      for (const key in this.formData) {
        this.formData[key] = "";
      }
      this.linkVisible = false;
    },
    selctCustConfirm(row) {
      this.formData.customerId = row.id;
      this.formData.customerName = row.customerName;
    },
  },
  components: { NewTable, SelectCustomer },
};
</script>

<style scoped lang="scss">
.footer {
  padding-right: 10px;
  text-align: right;
}
</style>
